<template>
  <div class="fill-height">
    <radial-bar-chart
      class="fill-height"
      :series="[ getStatValue('UXMAXVELREF') || 0 ]"
      :plot-options="{
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: getStatValue('CACGCSMXV') ? -2 : 25,
              fontSize: '24px'
            },
            total: {
              show: true,
              label: getStatValue('CACGCSMXV'),
              formatter: () => getStatValue('CACGCSMXV') ? getStatValue('CACGCSMXV') : 'N/A'
            }
          }
        }
      }"
      :tooltip="{
        enabled: true,
        y: {
          formatter: () => `${getStatValue('UXMAXVELREF')}%`,
          title: {
            formatter: () => getVariableName('UXMAXVELREF') + ':'
          }
        }
      }"
      :animations="{enabled: false}"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ $t('card_title.velocity') }} ({{ getVariableSuffix('CACGCSMXV') }}){{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </template>
      <template v-slot:footer>
        <div class="d-flex justify-center">
          <span class="font-weight-medium">{{ getVariableName('UXAVGVEL') }}: {{ getStatValue('UXAVGVEL') }}{{ getVariableSuffix('UXAVGVEL') }}</span>
        </div>
      </template>
    </radial-bar-chart>
  </div>
</template>

<script>
import RadialBarChart from '@/components/charts/RadialBarChart.vue'

export default {
  name: 'VelocityRadialChart',
  components: { RadialBarChart },
  props: {
    stats: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    variables: {
      type: Array,
      required: true
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  methods: {
    getVariableName(value) {
      return this.$t(`variables.${value}`)
    },
    getVariableSuffix(value) {
      return this.variables.find(variable => variable.value === value)?.suffix
    },
    getKeyWithAggregation(key) {
      return this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
    },
    getStatValue(key) {
      const aggregatedKey = this.getKeyWithAggregation(key)
      return this.stats[aggregatedKey]
    }
  }
}
</script>
